/**
 * SD-1218: the module codes the server can return from `GET Modules/Me`.
 *
 * Mirrors Synced/Models/ModuleCodes.cs in the backend repo. The code string is the contract
 * between the two, so a change here is a change there.
 *
 * The registry is data, not code: an admin can create codes that do not appear below, and
 * the server may return them before this file knows about them (they are simply ignored,
 * because no NavItem references them). These constants exist so that the codes the client
 * actually gates on are greppable and cannot be misspelled in a template.
 */
export const MODULES = {
  HOME: 'home',
  INBOX: 'inbox',
  EMAILS: 'emails',
  BILLS_TO_PAY: 'bills-to-pay',
  PAYMENTS: 'payments',
  INVOICES: 'invoices',

  /** SD-1249: the Time module (Timesheet). Every role may log its own time. */
  TIME: 'time',
  PAPERWORK: 'paperwork',
  TRANSACTIONS: 'transactions',

  /**
   * SD-1207. Unlike every other code here this one has no NavItem: bank feeds surface
   * inside Transactions and Settings rather than as a sidemenu entry. It is also seeded
   * RolloutState = Pilot with no plan grant, so it is denied to everyone -- super-admins
   * included -- until an organisation gets an explicit override.
   */
  BANK_FEEDS: 'bank-feeds',
  FLOWS: 'flows',
  AGENTS: 'agents',
  SUPPORT: 'support',
  SETTINGS: 'settings',

  /**
   * SD-1248. The "All clients" item's code. Like BANK_FEEDS it is not a module the client gates
   * on the entitlement set: the item has `requires: 'practice'` and shows exactly when
   * `GET practice/me` lists a practice, whatever Modules/Me says (see isNavItemVisible). The code
   * exists because every NavItem needs a unique requiredModule to be tracked by.
   */
  PRACTICE: 'practice',

  // ── SD-1229: features (dbo.Module.Kind = Feature), coded '<module>.<feature>' ──
  // A feature is granted only while its parent module is. Features never appear in the
  // sidemenu; gate them in templates with *appHasModule or in code with has$().

  /** Inbox Automator on a connected Gmail/Outlook mailbox. Paid tiers only. */
  INBOX_AUTOMATOR: 'emails.inbox-automator',

  /** New Xero bank transactions imported every day at 10:00 local time. Paid tiers only. */
  TRANSACTION_DAILY_SYNC: 'transactions.daily-sync'
};
